import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "mt-2" };
const _hoisted_2 = { class: "row" };
const _hoisted_3 = { class: "col-4 col-md-3" };
const _hoisted_4 = { class: "col-4 col-md-3" };
const _hoisted_5 = ["href"];
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("div", { class: "d-none d-md-block col-3" }, null, -1);
const _hoisted_7 = { class: "col-4 col-md-3" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_ozg_summary_item = _resolveComponent("g-ozg-summary-item");
    const _component_g_button = _resolveComponent("g-button");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createElementVNode("div", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getAllPages, (page) => {
                return (_openBlock(), _createBlock(_component_g_ozg_summary_item, {
                    page: page,
                    schema: _ctx.schema,
                    data: _ctx.data,
                    key: page.name,
                    onCommand: _ctx.onCommand
                }, null, 8, ["page", "schema", "data", "onCommand"]));
            }), 128))
        ]),
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                (!_ctx.page.isFirstPage)
                    ? (_openBlock(), _createBlock(_component_g_button, {
                        key: 0,
                        text: "<< Zurück",
                        "button-style": "btn-outline-secondary",
                        disabled: !_ctx.page.previousPage,
                        onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.onCommand('back', { page: _ctx.page }))),
                        isLoading: _ctx._isWorking
                    }, null, 8, ["disabled", "isLoading"]))
                    : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_4, [
                _createElementVNode("a", {
                    href: '/frontend/v1/forms/processes/' + _ctx.process.processID + '/print',
                    target: "_blank",
                    class: "btn btn-outline-secondary w-100"
                }, "Drucken", 8, _hoisted_5)
            ]),
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_g_button, {
                    text: _ctx.page.nextText,
                    disabled: !_ctx.page.nextCommand2,
                    onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.onCommand(_ctx.page?.nextCommand2, { page: _ctx.page }))),
                    isLoading: _ctx._isWorking
                }, null, 8, ["text", "disabled", "isLoading"])
            ])
        ])
    ], 64));
}
